
import { Link as RouterLink } from 'react-router-dom'
import PropTypes from 'prop-types'
import { themeV5 } from 'theme/v5'

const TextLink = ({ children, className, to, ...props }) => {
  return (
    <RouterLink
      sx={{
        color: themeV5.palette.text.link,
        ...className
      }}
      to={to}
      {...props}>
      {children}
    </RouterLink>
  )
}

TextLink.propTypes = {
  children: PropTypes.string,
  className: PropTypes.string,
  to: PropTypes.string.isRequired,
}

export default TextLink
